$(document).ready(function() {
	$("#sumButton").click(function() {
		$('#hotelName').val($('#hotelNameCollapse').val());
		$('#checkInDate').val($('#checkInDateCollapse').val());
		$('#checkOutDate').val($('#checkOutDateCollapse').val());

		$(".summary").slideUp("slow");
		$(".search-form-hotel").slideDown("slow");

	});
});